module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "vrbo-user-connection-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.vrbo")) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeVrboUserConnectionModal()
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-room-id"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user.vrbo_account && _vm.user.vrbo_account.active ?
    _vm.$t("rentals.detail.platforms.vrbo.disable_vrbo") :
    _vm.$t("rentals.detail.platforms.vrbo.enable_vrbo")) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15",
    on: {
      "click": function($event) {
        _vm.updateVrboUserConnection()
      }
    }
  }, [_c('switches', {
    attrs: {
      "theme": "bulma",
      "color": "blue",
      "type-bold": "false"
    },
    model: {
      value: (_vm.isVrboUserActive),
      callback: function($$v) {
        _vm.isVrboUserActive = $$v
      },
      expression: "isVrboUserActive"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-room-id"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.advertiser_id_label")) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "auto auto-onOff pull-right m-r-50 m-t-15"
  }, [_vm._v("\n                " + _vm._s(_vm.user.vrbo_account && _vm.user.vrbo_account.active ?
    _vm.user.vrbo_account.vrbo_advertiser_id :
    "") + "\n              ")])])])]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeVrboUserConnectionModal()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("button.cancel")) + "\n          ")])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29ecd0b9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/account/settings/modals/VrboUserConnectionModal.vue
// module id = 1365
// module chunks = 0